import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

/** O texto de cada destaque da vitrine: a etiqueta, o título e o resumo. */
export default function SlideCopy({
  icon: Icon,
  tag,
  title,
  text,
}: {
  icon: LucideIcon;
  tag: string;
  title: string;
  text: string;
}) {
  return (
    <div className="flex max-w-125 flex-col gap-3">
      <span className="inline-flex h-7 items-center gap-1.5 self-start rounded-pill bg-sidebar-card px-3 text-meta font-semibold text-sidebar-accent">
        <Icon aria-hidden className="size-3.5 stroke-2" />
        {tag}
      </span>
      <h2 className="m-0 text-display-lg leading-tight font-extrabold tracking-[-0.03em] text-balance text-white">
        {title}
      </h2>
      <p className="m-0 max-w-110 text-body-lg text-pretty text-sidebar-muted">{text}</p>
    </div>
  );
}

/** O cartão flutuante que fecha cada destaque, sobre o canto do cartão principal. */
export function FloatingNote({ children }: { children: ReactNode }) {
  return (
    <div className="-mt-7.5 -mr-4.5 flex items-center gap-3 self-end rounded-card bg-white px-3.5 py-3 text-ink shadow-dialog">
      {children}
    </div>
  );
}
